export default __webpack_public_path__ + "static/media/game_fi.ec9722e0.png";